import { render, staticRenderFns } from "./upLink.vue?vue&type=template&id=63e4124a&scoped=true&"
import script from "./upLink.vue?vue&type=script&lang=js&"
export * from "./upLink.vue?vue&type=script&lang=js&"
import style0 from "./upLink.vue?vue&type=style&index=0&id=63e4124a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e4124a",
  null
  
)

export default component.exports